import { render, staticRenderFns } from "./PayableReceivableCreateUpdate.vue?vue&type=template&id=2f7e8f7a&scoped=true&"
import script from "./PayableReceivableCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./PayableReceivableCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PayableReceivableCreateUpdate.vue?vue&type=style&index=0&id=2f7e8f7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7e8f7a",
  null
  
)

export default component.exports